export function normalizeUserPhone(value?: string | null): string | null {
  return (value || "").trim().replace(/[\s().-]/g, "") || null;
}
export function validUserPhone(value?: string | null): boolean {
  const phone = normalizeUserPhone(value);
  return phone === null || /^\+?[0-9]{7,15}$/.test(phone);
}
